/**
 * Light hero for inner pages (Contact, Locations, Consultation...). Renders the page's single <h1>.
 * Mobile-first: centred text on a soft brand tint background.
 */
export function PageHero({ icon: Icon, eyebrow, title, intro, introLines, testId }) {
  return (
    <section
      data-testid={testId}
      className="relative overflow-hidden bg-brand-50 py-12 text-ink sm:py-16 lg:py-20"
    >
      <div className="relative z-10 mx-auto max-w-3xl px-4 text-center sm:px-6 lg:px-8">
        {eyebrow ? (
          <span className="mb-4 inline-flex items-center gap-2 rounded-full border border-brand-200 bg-white px-4 py-1.5 text-xs font-bold sm:text-sm">
            {Icon ? <Icon className="h-4 w-4 text-brand-500" aria-hidden="true" /> : null}
            {eyebrow}
          </span>
        ) : null}
        <h1 className="font-heading text-4xl font-bold leading-tight sm:text-5xl lg:text-6xl">{title}</h1>
        {introLines?.length ? (
          <p className="mx-auto mt-4 max-w-3xl text-base leading-snug text-ink/70 sm:text-lg">
            {introLines.map((line) => (
              <span key={line} className="block sm:whitespace-nowrap">
                {line}
              </span>
            ))}
          </p>
        ) : intro ? (
          <p className="mx-auto mt-4 max-w-[56ch] text-base text-ink/70 sm:text-lg">{intro}</p>
        ) : null}
      </div>
    </section>
  );
}
